import { defineComponent as _defineComponent } from 'vue'
import { IProductDetailFooter } from '@/modules/catalog/services/products';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSideSheetFooter',
  props: {
  footer: {
    type: Array as PropType<IProductDetailFooter[]>,
    default: null
  }
},
  setup(__props) {



return { __sfc: true,NebraskaColors, BaseText, InitialAvatarIcon }
}

})